<template>
    <v-dialog v-model="modal" width="800">
        <v-card dark>
            <v-card-title>Editar usuario</v-card-title>
            <v-card-text>
            <v-select 
                label="Level" 
                v-model="user.user_level_id" 
                :items="levels"
                item-text='name'
                item-value="id"
                outlined dark></v-select>
            <v-text-field label="Nome" v-model="user.name" outlined dark
            ></v-text-field>
            <v-text-field label="Nickname" v-model="user.nickname" outlined dark></v-text-field>
            <v-text-field label="Email" v-model="user.email" outlined dark></v-text-field>
            <v-text-field label="Nova Senha (Deixar campo vazio para não mudar senha atual)" v-model="user.password" outlined dark></v-text-field>
            <v-text-field label="Confirmar Senha" v-model="user.password_confirmation" outlined dark></v-text-field>
            <v-textarea label="Bio" v-model="user.description" outlined dark></v-textarea>

            <v-row>
              <v-col cols="12" sm="6">
                <v-select label="Gênero" v-model="user.gender" :items="[
                  { text: 'Masculino', value: 'M' },
                  { text: 'Feminino', value: 'F' }
                ]" item-text="text" item-value="value" outlined dark></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field label="Data de Nascimento" v-model="user.birthday" outlined dark
                  placeholder="DD/MM/AAAA" type="date"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field label="País" v-model="user.country" outlined dark></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field label="Estado" v-model="user.estate" outlined dark></v-text-field>
              </v-col>
            </v-row>

            <v-text-field label="Instagram" v-model="user.instagram" outlined dark></v-text-field>
            <v-text-field label="Facebook" v-model="user.facebook" outlined dark></v-text-field>
            <v-text-field label="Twitter" v-model="user.twitter" outlined dark></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="fecharModal">Cancelar</v-btn>
                <v-btn color="success" @click="salvar()">Salvar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import UserService from '@/server/UserService';
import { getLevel } from '@/server/workService';

export default {
    name:'ModalUser',
    props:{
        listar:{type:Function}
    },
    data:() =>({
        modal:false,
        levels:[], 
        service: new UserService(),
        erros:{},
    }),
    computed:{
        user: {
            get(){return this.$store.getters['getUser']},
            set(dado){this.$store.dispatch('setUser', dado)}
        }
    },
    async mounted(){
        this.levels = await getLevel();
    },
    methods:{
        fecharModal(){
            this.modal = false;
            this.user = null;
        },
        abrirModal(){
            this.modal = true;
        },
        salvar(){
            this.service.update(this.user)
                .then(() => {                    
                    this.fecharModal()
                    this.listar()
                })
                .catch(erro => {
                    if(erro.response){
                        console.log(erro.response);
                        let resp = erro.response;
                        if(resp.status == 422){
                            this.erros = resp.data.erros;
                            alert(resp.data.message);
                        }
                    }else{
                            alert('Erro');
                    }
                })
        }
    }

}
</script>